export default __webpack_public_path__ + "static/media/photo-1506089676908-3592f7389d4d.56a08c5d.jpeg";